import initialState, { initialBpState } from './state'
import { fetchWikiRoutine, refreshWikiRoutine } from './actions'

const getBp = (state, bpId) => state.byBpId[bpId] || initialBpState

export default function buildingWikiReducer(state = initialState, action) {
  switch (action.type) {
    case fetchWikiRoutine.REQUEST: {
      const { bpId } = action.payload
      return {
        ...state,
        byBpId: {
          ...state.byBpId,
          [bpId]: { ...getBp(state, bpId), status: 'loading', error: null },
        },
      }
    }
    case fetchWikiRoutine.SUCCESS: {
      const { bpId, article } = action.payload
      const status = article?.status === 'ready' || article?.status === 'needs_review'
        ? article.status
        : article?.status === 'generating'
          ? 'regenerating'
          : article?.status || 'idle'
      return {
        ...state,
        byBpId: {
          ...state.byBpId,
          [bpId]: {
            ...getBp(state, bpId),
            article,
            status,
            lastFetchedAt: new Date().toISOString(),
            error: null,
          },
        },
      }
    }
    case fetchWikiRoutine.FAILURE: {
      const { bpId, error } = action.payload
      return {
        ...state,
        byBpId: {
          ...state.byBpId,
          [bpId]: { ...getBp(state, bpId), status: 'failed', error },
        },
      }
    }
    case refreshWikiRoutine.REQUEST: {
      const { bpId } = action.payload
      return {
        ...state,
        byBpId: {
          ...state.byBpId,
          [bpId]: { ...getBp(state, bpId), refreshInFlight: true, refreshNextAllowedAt: null },
        },
      }
    }
    case refreshWikiRoutine.SUCCESS: {
      const { bpId } = action.payload
      return {
        ...state,
        byBpId: {
          ...state.byBpId,
          [bpId]: { ...getBp(state, bpId), refreshInFlight: false, status: 'regenerating' },
        },
      }
    }
    case refreshWikiRoutine.FAILURE: {
      const { bpId, error, nextAllowed } = action.payload
      return {
        ...state,
        byBpId: {
          ...state.byBpId,
          [bpId]: {
            ...getBp(state, bpId),
            refreshInFlight: false,
            refreshNextAllowedAt: nextAllowed ?? null,
            error,
          },
        },
      }
    }
    default:
      return state
  }
}
